export const NOTIFICATION_JUST_CREATED = 'NOTIFICATION_JUST_CREATED'
